import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {PledgeStatusType, ShiftPledgeReportSummary} from '../../../../services/api.client';
import {PaymentProcessingFormComponent} from '../PaymentProcessingFormComponent';

@Component({
    selector: ('confirmedPending'),
    templateUrl: './ConfirmedToPendingComponent.html',
    styleUrls: ['./ConfirmedToPendingComponent.scss'],
    standalone: false
})

export class ConfirmedToPendingComponent implements AfterViewInit {
    private readonly _reports$ = new BehaviorSubject<ShiftPledgeReportSummary[]>(null);
    reports$: Observable<ShiftPledgeReportSummary[]> = this._reports$.asObservable();
    reports: ShiftPledgeReportSummary[];

    @ViewChild(PaymentProcessingFormComponent)
    form: PaymentProcessingFormComponent;

    submitReport(): void {
        this.form.submitConfirmedToPending()?.subscribe({next: (reports) => this._reports$.next(reports), error: () => {}});
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.form.form.get('displayPledgeStatus').reset(PledgeStatusType.Confirmed, {disabled: true});
            this.form.form.get('shiftPledgeStatus').reset(PledgeStatusType.Pending, {disabled: true});
        });
    }

}
